const authRoutes = [
    {
        path: '/userManage',
        name: 'userManage',
        component: () => import('../../views/Auth/userManage.vue'),
        meta: { title: 'menu.accountManage' }
    },
    {
        path: '/authManage',
        name: 'authManage',
        component: () => import('../../views/Auth/AuthManage.vue'),
        meta: { title: 'menu.permissionManage' }
    },
    {
        path: '/roleManage',
        name: 'roleManage',
        component: () => import('../../views/Auth/roleManage.vue'),
        meta: { title: 'menu.roleManage' }
    },
    {
        path: '/authGroupManage',
        name: 'authGroupManage',
        component: () => import('../../views/Auth/authGroupManage.vue'),
        meta: { title: 'menu.authGroupManage' }
    }
]

export default authRoutes
